module.exports = __webpack_public_path__ + "handbold_square-fcd77416547e980af802a4c1cd9e5af4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/handbold_square.jpg
// module id = 1162
// module chunks = 1 2